module.exports = __webpack_public_path__ + "static/media/SUMMARY_0013_02.5cae1cfd.webp";